import { Badge } from 'rsuite';
import { SelectedCardsMenu } from '@widgets/cards/menu';
import { useTranslation } from 'react-i18next';
import { SplitButton } from '@shared/ui/buttons';

export default function TableSelectedButton({ selected }) {
  const { t } = useTranslation();

  return (
    <div className="d-flex">
      <SplitButton
        text={
          <>
            <Badge className="custom-badge" content={selected.length} />
            {t('selected')}
          </>
        }
        menuComponent={SelectedCardsMenu}
        menuProps={{ data: selected }}
      />
    </div>
  );
}

// {
// 	"id": 1,
// 	"created_at": "2025-10-06 21:33:59",
// 	"updated_at": "2025-11-03 16:40:37",
// 	"details": {
// 			"bankName": "BfinanceBudget",
// 			"bank_public_name": "Bfinance Budget",
// 			"cardNumber": "4111111111111101",
// 			"paymentMethod": "visa"
// 	},
// 	"owner": {
// 			"id": 2,
// 			"name": "SatansNeighbours"
// 	},
// 	"status": "Active",
// 	"type": "prepaid",
// 	"limit": 1000,
// 	"real_limit": 0,
// 	"currency": "USD",
// 	"group": {
// 			"id": 61,
// 			"name": "New hey ho",
// 			"avatar": {
// 					"name": "instagram",
// 					"color": "#44ABCA"
// 			},
// 			"color": null
// 	},
// 	"note": null
// }
